import React from 'react';
import { Container } from '@mui/material';
import PatientList from '../components/PatientList';

const PatientsPage: React.FC = () => {
  return (
    <Container maxWidth="xl">
      <PatientList />
    </Container>
  );
};

export default PatientsPage; 